export default "__VITE_ASSET__CXn8qO0p__"